import React from 'react'
import { Row, Col, Container } from 'react-bootstrap'
import { StaticQuery, graphql } from 'gatsby'
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import styled from 'styled-components'
import Typewriter from 'typewriter-effect'

class Hero extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            height: 0,
            width: 0
        }
    }

    updateDimensions = () => {
        if (this.state.height !== window.innerHeight) {
            this.setState({height: window.innerHeight})
        }
        if (this.state.width !== window.innerWidth) {
            this.setState({width: window.innerWidth})
        }
    }

    
    componentDidMount() {
        this.setState({height: window.innerHeight, width: window.innerWidth})
        window.addEventListener('resize', this.updateDimensions)
    }
    
    componentWillUnmount() {
        window.removeEventListener('resize', this.updateDimensions)
    }

    render() {

        const Section = styled.section`
            position: relative;            
            background-size: cover;
            background-repeat: no-repeat;
            @media (max-width:767px) {
                background-size: 100%;
                margin-top: 100px;
                height: 250px;                
            }
        `

        const Overlay = styled.div`
            width: 100%;
            display: flex;
            align-items: center;
            background-color: rgba(0,0,0,.5);
            @media (max-width:767px) {                
                height: 250px !important;            
            }
        `

        const Heading1 = styled.h1`
            font-size: 80px;
            font-family: Poppins;
            line-height: 80px;
            color: #fff;
            font-weight: bold;
            text-transform: uppercase;
            @media (min-width:768px) {
                margin-left: 4px;
            }            
            @media (min-width:768px) and (max-width:1500px) {
                font-size: 70px;
                padding-top: 100px;
            }
            @media (max-width:767px) {
                font-size: 30px;
                line-height: 40px;
                margin-left: 2px;
            }
        `

        const Heading2 = styled.h2`
            font-size: 50px;
            color: #fff;
            font-weight: 700;
            text-transform: uppercase;
            background: -webkit-linear-gradient(left, #c1eb18 , #65ff00);
            background: -o-linear-gradient(right, #c1eb18, #65ff00);
            background: -moz-linear-gradient(right, #c1eb18, #65ff00);
            background: linear-gradient(to right, #c1eb18, #65ff00); 
           -webkit-background-clip: text;
           -webkit-text-fill-color: transparent;
            @media (max-width:767px) {
                font-size: 20px;
                line-height: 40px;
            }
           @media (min-width:768px) and (max-width:1500px) {
                font-size: 40px;
            }
        `

        const Type = styled.div`
            font-size: 50px;
            line-height: 50px;
            color: #fff;
            text-transform: uppercase;
            @media (min-width:768px) {
                margin-left: 6px;
            }            
            @media (min-width:768px) and (max-width:1500px) {
                font-size: 50px;
                line-height: 50px;
                padding-bottom: 150px;
            }
            @media (max-width:767px) {
                font-size: 30px;
                line-height: 30px;
                margin-left: 2px;
                
            }
            span {
                font-family: Teko;
            }
        `
        const Content = styled.div`
            position: relative;
            z-index: 10
        `

        const Separator = styled.div`
            height: 5px;
            width: 50px;
            background-color: #C1EB18;
            margin-bottom: 30px;
            @media (min-width:768px) {
                margin-left: 6px;
            }
            @media (max-width:767px) {
                margin-left: 2px;
            }
        `

        const BottomContent = styled.div`
            position: absolute;
            width: 100%;
            bottom: -10%;
            z-index: 2;
            @media (min-width:1025px) and (max-width: 1400px) {    
                bottom: -40%;
            }
            @media (max-width:767px) {
                position: relative;
                bottom: 0;
            } 
            @media (min-width:768px) and (max-width: 1023px) {    
                bottom: -25%;
            }
        `

        const ServiceCol = styled(Col)`
            padding: 0;
            border-right: #444;
            &.no-border {
                border-right: none;
            }
            @media (max-width:500px) {
                border-right:none;
            }
        `

        const Service = styled.div`
            min-height: 300px;
            background-color: #111;
            transition: .2s;
            display: flex;
            justify-content: center;
            flex-direction: column;
            &:hover {
                background-color: #222;
            }
        `
        const ServiceContent = styled.div`
            padding: 40px;
            color: #fff;
        `
        const ServiceHeading = styled.h3`
            font-size: 30px;
            font-weight: 400;
            font-family: Antonio,sans-serif;
        `        
        const ServiceSeparator = styled.div`
            height: 5px;
            width: 50px;
            background-color: #c1eb18;
            margin-bottom: 10px;
        `

        const ServiceIcon = styled.div`
      margin-bottom: 20px;
      img {
        max-height: 70px;
        max-width: 70px;
        width: 100%;
        height: auto;
      }
    `

        const ServiceText = styled.p`
            font-size: 14px;
            font-weight: 300;
            color: #c5c5c5;
        `
        const Color = styled.span`            
            font-weight: bold;
            color: #c1eb18;            
        `

        const { data } = this.props;
        const imageData = getImage(data.background.childImageSharp.gatsbyImageData);
        
        return (
            <Section>
                <Overlay style={{ height: `${this.state.width > 500 ? this.state.height : 350}px` }}>
                    <GatsbyImage
                        image={imageData}
                        alt="Servidor Dedicado VASCO Solutions"
                        style={{ position: 'absolute', width: '110%', height: '100%', opacity: 0.7 }}
                    />
                    <Container>
                        <Content>
                            <Heading1>
                                Servidor Dedicado
                            </Heading1>
                            <Heading2>
                                Hosting dedicado al mejor precio
                            </Heading2>
                            <Separator />
                            <Heading2>
                                <Type>
                                    <Typewriter
                                        options={{
                                            strings: [
                                                'Garantía de reembolso por 30 días',
                                                'Discos SSD o HDD',
                                                'Tu espacio exclusivo en la web',
                                                'Potencia sin límites',
                                                'Control absoluto',
                                            ],
                                            autoStart: true,
                                            loop: true,
                                        }}
                                    />
                                </Type>
                            </Heading2>
                        </Content>
                    </Container>
                </Overlay>
                <BottomContent>
                    <Container>
                        <Row>
                            <ServiceCol md={4} style={{ borderRight: this.state.width > 500 ? "1px solid #444" : "none" }}>
                                <Service>
                                    <ServiceContent>
                                        <ServiceIcon>
                                            <GatsbyImage image={this.props.image1} alt="Servidor dedicado no administrado" />
                                        </ServiceIcon>
                                        <ServiceHeading>
                                            Dedicado no administrado
                                        </ServiceHeading>
                                        <ServiceSeparator />
                                        <ServiceText>
                                            Configura tu sistema, elige tus aplicaciones y maximiza la eficiencia sin restricciones innecesarias. Tú decides cada configuración y ajuste. Sin tarifas adicionales por servicios de administración.
                                        </ServiceText>
                                    </ServiceContent>
                                </Service>
                            </ServiceCol>
                            <ServiceCol md={4} style={{ borderRight: this.state.width > 500 ? "1px solid #444" : "none" }}>
                                <Service>
                                    <ServiceContent>
                                        <ServiceIcon>
                                            <GatsbyImage image={this.props.image2} alt="Servidores SSD y HDD" />
                                        </ServiceIcon>
                                        <ServiceHeading>
                                            Servidores SSD y HDD
                                        </ServiceHeading>
                                        <ServiceSeparator />
                                        <ServiceText>
                                            Los servidores SSD son ideales para aplicaciones de alto rendimiento y necesidades críticas de fiabilidad, mientras que los servidores dedicados HDD son más adecuados para almacenamiento masivo.
                                        </ServiceText>
                                    </ServiceContent>
                                </Service>
                            </ServiceCol>
                            <ServiceCol md={4}>
                                <Service>
                                    <ServiceContent>
                                        <ServiceIcon>
                                            <GatsbyImage image={this.props.image3} alt="Servidor dedicado Colombia" />
                                        </ServiceIcon>
                                        <ServiceHeading>
                                            Control absoluto
                                        </ServiceHeading>
                                        <ServiceSeparator />
                                        <ServiceText>
                                            En <Color>VASCO Solutions,</Color> entendemos que la necesidad de control sobre tu entorno digital es fundamental. Es por eso que ofrecemos servidores dedicados no gestionados, proporcionándote
                                            el máximo control y una seguridad inigualable.
                                        </ServiceText>
                                    </ServiceContent>
                                </Service>
                            </ServiceCol>
                        </Row>
                    </Container>
                </BottomContent>
            </Section>
        )
    }
}

const Iconos = (props) => (
    <StaticQuery
        query={graphql`
        {
          background: file(relativePath: { eq: "server.jpg" }) {
                    childImageSharp {
                        gatsbyImageData(layout: CONSTRAINED, width: 2000)
                    }
          }          
          image1: file(relativePath: { eq: "icons/rack.png" }) {
            childImageSharp {
              gatsbyImageData(
              layout: CONSTRAINED
              placeholder: DOMINANT_COLOR
              quality: 80
              formats: [AUTO, WEBP, AVIF]
              width: 70
            )
            }
          }
          image2: file(relativePath: { eq: "icons/dedicated.png" }) {
            childImageSharp {
              gatsbyImageData(
              layout: CONSTRAINED
              placeholder: DOMINANT_COLOR
              quality: 80
              formats: [AUTO, WEBP, AVIF]
              width: 70
            )
            }
          }
          image3: file(relativePath: { eq: "icons/managedserver.png" }) {
            childImageSharp {
              gatsbyImageData(
              layout: CONSTRAINED
              placeholder: DOMINANT_COLOR
              quality: 80
              formats: [AUTO, WEBP, AVIF]
              width: 70
            )
            }
          }
        }
      `}
        render={(data) => {            
            const image1 = getImage(data.image1.childImageSharp.gatsbyImageData);
            const image2 = getImage(data.image2.childImageSharp.gatsbyImageData);
            const image3 = getImage(data.image3.childImageSharp.gatsbyImageData);
            return <Hero data={data} image1={image1} image2={image2} image3={image3}{...props} />;
        }}
    />
);

export default Iconos;
